import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../components/templates/ServicePageTemplate'

const artworkConfig: ServicePageConfig = {
  title: 'Artwork - Bespoke Shopping | FGA Prestige',
  description: 'Acquiring museum-quality art pieces and investment-grade masterworks through our exclusive bespoke shopping service.',
  slug: 'bespoke-shopping/artwork',
  heroImage: '/Bespoke Shopping/Retail Partners/ARTWORK/hero.png',
  serviceName: 'ARTWORK',
  whySectionA: {
    title: 'Canvas & Capital',
    content: 'In the rarified world of museum-quality art, where a single brushstroke can command eight figures and provenance matters as much as palette, we’ve carved out something truly special. While others chase trends, we’ve spent decades cultivating the relationships and expertise that matter—direct connections with Sotheby’s and Christie’s, an in-house escrow division and consultant services that have helped build some of Asia’s most prestigious private collections.',
    image: '/Bespoke Shopping/Retail Partners/ARTWORK/body/1.png',
    imageAlt: 'Art Expert Consultation'
  },
  whySectionC: {
    title: 'The Art Market Today',
    content: 'The contemporary art market is experiencing unprecedented growth, with global auction sales reaching record highs. From emerging digital artists to established masters, the landscape is evolving rapidly. Collectors are increasingly drawn to works that combine aesthetic beauty with cultural significance and investment potential. Smart buyers recognize that exceptional art transcends mere decoration—it becomes a legacy piece that appreciates over time while bringing daily inspiration.',
    image: '/Bespoke Shopping/Retail Partners/ARTWORK/body/2.png',
    imageAlt: 'Art Market Trends'
  },
  whySectionB: {
    title: 'Why Choose FGA Prestige for Art Acquisition',
    benefits: [
      {
        title: 'Curated Selection Process',
        description: 'Our expert curators work directly with galleries, estates, and artists to source pieces that align with your aesthetic preferences and investment goals.'
      },
      {
        title: 'Market Intelligence',
        description: 'Access to real-time market data, auction results, and emerging trends to ensure your acquisitions maintain or increase in value.'
      },
      {
        title: 'Seamless Acquisition',
        description: 'End-to-end support from initial consultation through authentication, acquisition, and secure delivery of your artwork.'
      }
    ],
    image: '/Bespoke Shopping/Retail Partners/ARTWORK/body/3.png',
    imageAlt: 'Luxury art collection'
  },
  masterpieceBackgroundImage: '/Bespoke Shopping/Retail Partners/ARTWORK/CTA_Banner/banner.png'
}

const ArtworkPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Artwork - Bespoke Shopping | FGA Prestige</title>
        <meta name="description" content="Acquiring museum-quality art pieces and investment-grade masterworks through our exclusive bespoke shopping service." />
        <meta property="og:title" content="Artwork - Bespoke Shopping | FGA Prestige" />
        <meta property="og:description" content="Acquiring museum-quality art pieces and investment-grade masterworks through our exclusive bespoke shopping service." />
        <meta property="og:url" content="https://fgaprestige.com/bespoke-shopping/artwork" />
        <meta property="og:image" content="/Bespoke Shopping/Retail Partners/ARTWORK/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Artwork Collection" />
      </Helmet>
      
      <ServicePageTemplate config={artworkConfig} />
    </>
  )
}

export default ArtworkPage